<template>
  <div>
    <!-- {{ destinationId }}
    <pre>
    <h3>{{callData}}</h3>
    <pre>{{flow_down}}</pre>
    <pre>{{flow_up}}</pre>
  </pre> -->
    <div class="div-row font-color-black">
      <div class="widthdiv1 carddiv">
        <div class="padding-10" style="position: relative">
          <div style="position: absolute; right: 10px">
            <vs-button
              radius
              color="gray"
              type="flat"
              icon="settings"
              class="btn-setting"
              @click="$bvModal.show('setting-machine')"
            ></vs-button>
            <b-modal
              id="setting-machine"
              no-close-on-backdrop
              size="lg"
              hide-header-close
              centered
            >
              <template #modal-header>
                <div>
                  <h4 style="color: #32c040">Machine Infomation Status</h4>
                </div>
              </template>
              <div
                v-for="(list, i) in infoNew"
                class="mb-3"
                :key="i"
                style="display: flex; align-items: center"
              >
                <label
                  :for="'machine_' + i"
                  style="width: 130px; text-align: end; margin-right: 5px"
                  v-if="i != 'id'"
                  >{{ label[i] }} :</label
                >
                <!-- <input v-if="i=='mac'" type="numbar" :id="'machine_'+i" v-model="infoNew[i]" style="border-radius:10px; padding:2px;">
          <input v-else-if="i=='Tel'" type="tel" :id="'machine_'+i" v-model="infoNew[i]" style="border-radius:10px; padding:2px;"> -->

                <vs-input
                  :id="'machine_' + i"
                  v-if="i != 'id'"
                  v-model="infoNew[i]"
                />
                <!-- <vs-input size="default" v-model="infoNew[i]" style="color:var(-text-color-2)"/> -->
              </div>
              <template #modal-footer="{}">
                <vs-button
                  color="success"
                  class="mr-2 btnBorderpop"
                  @click="editMachine(getChartData)"
                  type="filled"
                  >Save</vs-button
                >
                <vs-button
                  class="btnBorderpop"
                  color="dark"
                  @click="$bvModal.hide('setting-machine')"
                  type="flat"
                  >Cancel</vs-button
                >
              </template>
            </b-modal>
          </div>
          <ul class="list-none padding-div1-text" v-if="callData">
            <li>
              <h5>
                ไลน์เครื่องจักร/แผนก :
                {{ info.line }}
              </h5>
            </li>

            <br />
            <li>
              <h5>เลขรหัสประจำเครื่อง : {{ info.serial }}</h5>
            </li>
            <br />
            <li>
              <h5>ชื่อเครื่องจักร : {{ info.name }}</h5>
            </li>
            <br />
            <li>
              <h5>ยี่ห้อเครื่องจักร : {{ info.brand }}</h5>
            </li>
            <br />
            <li>
              <h5>รุ่นเครื่องจักร : {{ info.model }}</h5>
            </li>
            <br />
            <li>
              <h5>ชื่อผู้รับผิดชอบ : {{ info.officer }}</h5>
            </li>
            <br />

            <li>
              <h5>เบอร์ติดต่อ : {{ info.phone }}</h5>
            </li>
          </ul>
          <div class="container-fluid header-top2">
            <img
              style="width: 100%"
              src="@/assets/images/hino element/machine.gif"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="div-space widthdiv">
        <div class="div-row">
          <div class="carddiv div_item_flex3_1_1 p-3" v-if="callData">
            <ul class="list-none">
              <li><h3 class="text_b">Surface Temperature</h3></li>
              <br />
              <li><h4 class="text_b">Temp upper</h4></li>
              <li>
                <div class="li-div2">
                  <div class="div2st">
                    <img
                      class="img-div2"
                      src="@/assets/images/hino element/chart_mathlab.gif"
                    />
                    <!-- <h3 class="text-div2">Temp upper</h3> -->
                  </div>
                  <div class="width_item2">
                    <h2 class="text-temp2">
                      <a class="text_b"> {{ callData.data.temp_up }} °C </a>
                      <!-- <sup style="font-size: 1rem; top: -2em">°C</sup> -->
                    </h2>
                  </div>
                  <div class="width_item2 ml-2">
                    <br />
                    <div class="item2_div1">
                      <div style="display: flex; align-items: flex-end">
                        <div style="width: 20%; color: #b85bff">max</div>
                        <div style="width: 70%" class="text_temp_small">
                          {{ maxTU }} °C
                        </div>
                      </div>
                      <div
                        class="mt-1"
                        style="display: flex; align-items: flex-end"
                      >
                        <div style="width: 20%; color: #ff70a5">min</div>
                        <div style="width: 70%" class="text_temp_small">
                          {{ minTU }} °C
                        </div>
                      </div>
                      <br /><br />
                      <div class="item2_div2">
                        <div>
                          <ul>
                            <li class="item2_flex">
                              Date :
                              {{
                                $moment(callData.timestamp).format("YYYY-MM-DD")
                              }}
                            </li>
                            <li class="item2_flex">
                              Time :
                              {{
                                $moment(callData.timestamp).format("HH:mm:ss")
                              }}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <br />
              <li><h4 class="text_b mt-2">Temp down</h4></li>
              <li>
                <div class="li-div2">
                  <div class="div2st">
                    <img
                      class="img-div2"
                      src="@/assets/images/hino element/chart_mathlab.gif"
                    />
                    <!-- <h3 class="text-div2">Temp down</h3> -->
                  </div>
                  <div class="width_item2">
                    <h2 class="text-temp2">
                      <a class="text_b"> {{ callData.data.temp_down }} °C</a>
                      <!-- <sup style="font-size: 1rem; top: -2em">°C</sup> -->
                    </h2>
                  </div>
                  <div class="width_item2 ml-2">
                    <br />
                    <div class="item2_div1">
                      <div style="display: flex; align-items: flex-end">
                        <div style="width: 20%; color: #b85bff">max</div>
                        <div style="width: 70%" class="text_temp_small">
                          {{ maxTD }} °C
                          <!-- <sup style="font-size: 0.7rem; top: -1em"
                            >°C</sup
                          > -->
                        </div>
                      </div>
                      <div
                        class="mt-1"
                        style="display: flex; align-items: flex-end"
                      >
                        <div style="width: 20%; color: #ff70a5">min</div>
                        <div style="width: 70%" class="text_temp_small">
                          {{ minTD }} °C
                        </div>
                      </div>
                      <br /><br />
                      <div class="item2_div2">
                        <div>
                          <ul>
                            <li class="item2_flex">
                              Date :
                              {{
                                $moment(callData.timestamp).format("YYYY-MM-DD")
                              }}
                            </li>
                            <li class="item2_flex">
                              Time :
                              {{
                                $moment(callData.timestamp).format("HH:mm:ss")
                              }}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="div-space div-graph">
            <div class="carddiv div_item_flex3_1_2 padding-10">
              <chart
                :text="'Temp upper'"
                colorgraph="#EF9BD8"
                :heightgrapg="100"
                :datasets3="TUChartData"
                v-if="TUChartData"
                v-on:max-min="maxminTU"
              />
            </div>
            <br />
            <div class="carddiv div_item_flex3_1_2 padding-10">
              <chart
                :text="'Temp down'"
                colorgraph="#b85bff"
                :heightgrapg="100"
                :datasets3="TDChartData"
                v-if="TDChartData"
                v-on:max-min="maxminTD"
              />
            </div>
          </div>
        </div>
        <br />
        <div class="div-row" v-if="callData">
          <div class="carddiv p-3 div_item_flex3_1_1">
            <ul class="list-none">
              <li><h3 class="text_b">Flow Rate</h3></li>
              <br />
              <li><h4 class="text_b">Flow upper</h4></li>
              <li>
                <div class="li-div2">
                  <div align="center" class="div3st1">
                    <img
                      class="img-div2"
                      src="@/assets/images/hino element/watergater-flow-animation (1).gif"
                    />
                    <!-- <h3 class="text-div2">01</h3> -->
                  </div>
                  <div :key="rediv" align="center" class="div3st2">
                    <h6
                      style="
                        position: absolute;
                        top: 70%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                      "
                    >
                      <h2 class="text-temp2">
                        <a class="text_b"> {{ callData.data.flow_up }} </a>
                      </h2>
                      L/min
                    </h6>

                    <!-- <vue-gauge
                      :refid="'gauge1' + item.key"
                      :options="{
                        arcColors: ['#EF9BD8', '#E0E0E0'],
                        hasNeedle: true,
                        arcPaddingColor: 'red',
                        outerNeedle: true,
                        needleStartValue: 0,
                        needleColor: 'red',
                        needleValue: maxFRU_miter,
                        arcDelimiters: [74],
                        rangeLabel: ['0', '100'],
                        needleUpdateSpeed: 1,
                      }"
                    ></vue-gauge> -->
                    <vue-gauge
                      :refid="'gauge1' + item.key"
                      :options="{
                        hasNeedle: true,
                        outerNeedle: true,
                        needleStartValue: 0,
                        needleColor: 'red',
                        arcColors: ['#EF9BD8', '#E0E0E0'],
                        needleValue: meterFRU.maxflow,
                        arcDelimiters: [flow_up],
                        rangeLabel: ['0', '100'],
                        needleUpdateSpeed: 1,
                      }"
                    ></vue-gauge>
                  </div>
                </div>
              </li>
              <li><h4 class="text_b">Flow down</h4></li>
              <li>
                <div class="li-div2">
                  <div align="center" class="div3st1">
                    <img
                      class="img-div2"
                      src="@/assets/images/hino element/watergater-flow-animation (1).gif"
                    />
                    <!-- <h3 class="text-div2">02</h3> -->
                  </div>
                  <div :key="rediv" align="center" class="div3st2">
                    <h6
                      style="
                        position: absolute;
                        top: 70%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                      "
                    >
                      <h2 class="text-temp2">
                        <a class="text_b"> {{ callData.data.flow_down }} </a>
                      </h2>
                      L/min
                    </h6>
                    <!-- <vue-gauge
                      :refid="'gauge2' + item.key"
                      :options="{
                        arcColors: ['#FAD02C', '#E0E0E0'],
                        hasNeedle: true,
                        outerNeedle: true,
                        needleStartValue: 0,
                        needleColor: 'red',
                        needleValue: 85,
                        arcDelimiters: [flow_down],
                        chartWidth: 240,

                        rangeLabel: ['0', '100'],
                        needleUpdateSpeed: 1,
                      }"
                    ></vue-gauge> -->
                    <vue-gauge
                      :refid="'gauge2' + item.key"
                      :options="{
                        hasNeedle: true,
                        outerNeedle: true,
                        needleStartValue: 0,
                        needleColor: 'red',
                        arcColors: ['#FAD02C', '#E0E0E0'],
                        needleValue: meterFRD.maxflow,
                        arcDelimiters: [flow_down],
                        rangeLabel: ['0', '100'],
                        needleUpdateSpeed: 1,
                      }"
                    ></vue-gauge>
                  </div>
                </div>
              </li>
              <!-- <img  style="width: 20%;" src="@/assets/images/hino element/watergater-flow-animation (1).gif" alt=""></li> -->
            </ul>
          </div>
          <div class="div-space div-graph">
            <div class="carddiv div_item_flex3_1_2 padding-10">
              <chart
                :text="'Flow upper'"
                colorgraph="#EF9BD8"
                :heightgrapg="100"
                :datasets3="FUChartData"
                v-on:max-min="maxminFRU"
                v-if="FUChartData"
              />
            </div>
            <br />
            <div class="carddiv div_item_flex3_1_2 padding-10">
              <chart
                :text="'Flow down'"
                colorgraph="rgba(247, 209, 59)"
                :heightgrapg="100"
                :datasets3="FDChartData"
                v-on:max-min="maxminFRD"
                v-if="FDChartData"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <br />
    <div class="div-row">
      <div class="carddiv div-dataset1">
        <dataset
          :header="'upper'"
          :idgraph="'grapha'"
          :colorgraph="'rgba(223, 83, 83, .5)'"
          :dataA="dataA"
          :id="destinationId"
        />
      </div>
      <div class="carddiv div-dataset2">
        <dataset
          :header="'down'"
          :idgraph="'graphb'"
          :colorgraph="'rgba(217, 130, 242, .5)'"
          :dataA="dataA"
          :id="destinationId"
        />
        <!-- <vs-row class="mb-3 mt-3">
          <h4>Dataset 02</h4>
          <vs-spacer />
            <vs-icon class="ml-2" icon="settings"></vs-icon>
        </vs-row>
        <div style="position: relative; width: 100%">
          <Scatterchart2 :dataA="dataA" />
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import miter from "./miter.vue";
import chart from "./chart.vue";
import VueGauge from "vue-gauge";

import dataset from "./../../components/BodyOutLine/dataset.vue";
export default {
  components: { miter, VueGauge, chart, dataset },
  props: ["item", "destinationId"],
  data() {
    return {
      rediv: 0,
      interval2: null,
      options_select: [
        { text: "3 hr", value: 1 },
        { text: "6 hr", value: 2 },
        { text: "12 hr", value: 3 },
      ],
      select_scater: 1,
      nameid: null,
      infoNew: {
        line: "ไลน์เครื่องจักร/แผนก",
        serial: "เลขรหัสประจำเครื่อง",
        name: "ชื่อเครื่องจักร",
        brand: "ยี่ห้อเครื่องจักร",
        model: "รุ่นเครื่องจักร",
        officer: "ผู้รับผิดชอบ",
        phone: "Tel.",
      },
      info: {
        line: "ไลน์เครื่องจักร/แผนก",
        serial: "เลขรหัสประจำเครื่อง",
        name: "ชื่อเครื่องจักร",
        brand: "ยี่ห้อเครื่องจักร",
        model: "รุ่นเครื่องจักร",
        officer: "ผู้รับผิดชอบ",
        phone: "Tel.",
      },
      label: {
        line: "ไลน์เครื่องจักร/แผนก",
        serial: "เลขรหัสประจำเครื่อง",
        name: "ชื่อเครื่องจักร",
        brand: "ยี่ห้อเครื่องจักร",
        model: "รุ่นเครื่องจักร",
        officer: "ผู้รับผิดชอบ",
        phone: "Tel.",
      },
      callData: undefined,
      TUChartData: undefined,
      TDChartData: undefined,
      FUChartData: undefined,
      FDChartData: undefined,
      interval: null,
      maxTU: 0,
      minTU: 0,
      maxTD: 0,
      minTD: 0,
      meterFRU: {
        flow: 0,
        maxflow: 0,
        downflow: 0,
      },
      meterFRD: {
        flow: 0,
        maxflow: 0,
        downflow: 0,
      },
    };
  },
  methods: {
    async geChart() {
      try {
        this.callData = await this.$API.get(
          `hino/getinfo/${this.destinationId}`
        );
        this.callData = this.callData.data;
        let res = await this.$API.get(`hino/getchart/${this.destinationId}`);
        // console.log("hino/getchart", res);
        this.TUChartData = {
          data: res.data.temp_up,
          labels: res.data.timestamp,
        };
        this.TDChartData = {
          data: res.data.temp_down,
          labels: res.data.timestamp,
        };
        this.FUChartData = {
          data: res.data.flow_up,
          labels: res.data.timestamp,
        };
        this.FDChartData = {
          data: res.data.flow_down,
          labels: res.data.timestamp,
        };
      this.rediv += 1;

      } catch (error) {
        console.log(error);
      }
      this.interval = setTimeout(() => {
      this.geChart();
    }, 1000 * 10);
    },
    async getMachine() {
      try {
        let res = await this.$API.get(`hino/getmachine/${this.destinationId}`);
        console.log("hino/getmachine/", res);
        for (const key in res.data) {
          this.infoNew[key] = res.data[key];
          this.info[key] = res.data[key];
        }
        // this.info = res.data
        // this.infoNew = res.data
      } catch (error) {
        console.log(error);
      }
    },
    async editMachine() {
      try {
        console.log(this.infoNew);
        let res = await this.$API.post(`hino/editmachine`, this.infoNew);
        console.log(res);
        this.getMachine();
        this.$bvModal.hide("setting-machine");
      } catch (error) {
        console.log(error);
      }
    },
    maxminTU(value) {
      this.maxTU = value[0];
      this.minTU = value[1];
    },
    maxminTD(value) {
      this.maxTD = value[0];
      this.minTD = value[1];
    },
    maxminFRU(value) {
      this.meterFRU.maxflow = parseFloat(value[0]);
      this.meterFRU.downflow = value[1];
    },
    maxminFRD(value) {
      this.meterFRD.maxflow = parseFloat(value[0]);
      this.meterFRD.downflow = value[1];
    },
  },
  async mounted() {
    this.getMachine();
    this.geChart();
  },
  beforeDestroy() {
    clearTimeout(this.interval);
  },
  computed: {
    flow_down() {
      return this.callData.data.flow_down <= 0
        ? 0.01
        : this.callData.data.flow_down >= 100
        ? 99
        : this.callData.data.flow_down;
    },
    flow_up() {
      return this.callData.data.flow_up <= 0
        ? 0.01
        : this.callData.data.flow_up >= 100
        ? 99
        : this.callData.data.flow_up;
    },
  },
};
</script>

<style lang="scss" scoped>
.select-date {
  display: flex;
  align-items: center;
  color: #808080;
  flex-wrap: wrap;
  .date-range {
    display: flex;
    align-items: center;
    gap: 5px;
    border: 1px #808080 solid;
    border-radius: 30px;
    padding: 8px;
    background-color: #fff;
  }
}
.div-space {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.div-graph {
  width: 50%;
  height: 100%;
}
.div_item_flex {
  display: flex;
}
.padding-10 {
  padding: 10px;
}
// .padding-20 {
//   padding: 20px;
// }
.list-none {
  list-style: none;
}
.div-row {
  display: flex;
  width: 100%;
}
.div-row-grapg {
  display: flex;
  width: 100%;
  height: 50%;
}
.widthdiv1 {
  width: 28%;
  margin-right: 20px;
}
.widthdiv1-1 {
  width: 28%;
  // margin-right: 20px;
}
.btnBorderpop {
  border-radius: 20px;
  width: 80px;
}
.widthdiv1-2 {
  width: 28%;
  // margin-right: 20px;
}
.widthdiv {
  width: 72%;
}
.width_item2 {
  width: 35%;
}
.width_div3 {
  margin-left: 20px;
  // display: grid;
}
.carddiv {
  height: auto;
  background: var(--background-color-sidebar);
  border-radius: 20px;
  display: block;
  //   -webkit-box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.1);
  //   -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.li-div2 {
  display: flex;
  align-items: center;
}
.div2st {
  position: relative;
  width: 30%;
}
.div3st1 {
  position: relative;
  width: 40%;
}
.div3st2 {
  position: relative;
  width: 70%;
}
.item2_flex {
  display: flex;
  white-space: nowrap;
}
.item2_div1 {
  font-size: 0.8rem;
}
.item2_div2 {
  /* margin-top: 10px;
  margin-right: 10px; */
  /* float: right; */
  display: flex;
  justify-content: flex-end;
  // justify-content: center;
  // font-size: 0.1rem;
}
.text-temp2 {
  font-size: 2rem;
}
.img-div2 {
  width: 70%;
  margin-top: 15px;
  margin-left: 15px;
}
.img-div3 {
  width: 100%;
  margin-top: 15px;
  margin-left: 15px;
}
.text-div2 {
  position: absolute;
  top: 10px;
}
.text_b {
  font-weight: 600;
}
.text_temp_small {
  font-size: 1.2rem;
  font-weight: 600;
}
.container-fluid {
  display: flex;
  justify-content: center;
}
// .header-top1 {
// margin-bottom: 5em;
// margin: 20px;
// }
.header-top2 {
  margin-top: 3em;
}
.div_item_flex3_1_1 {
  width: 50%;
}
.div_item_flex3_1_2 {
  // width: 100%;
  margin-left: 20px;
  height: 50%;
}
.padding-div1-text {
  padding: 20px;
}
.font-color-black {
  color: #4d4f5c;
}
.div-dataset1 {
  width: 50%;
  padding: 10px;
  margin-right: 5px;
}
.div-dataset2 {
  width: 50%;
  padding: 10px;
  margin-left: 10px;
}
@media only screen and (max-width: 700px) {
  .div-row {
    flex-wrap: wrap;
  }
  .div_item_flex {
    flex-wrap: wrap;
  }
  .widthdiv {
    width: 100%;
  }
  .widthdiv1 {
    width: 100%;
    margin-right: 0;
    margin-bottom: 20px;
  }
  .header-top1 {
    margin-bottom: 2em;
    margin-top: 1em;
  }
  .header-top2 {
    margin-top: 0;
  }
  .width_div3 {
    margin-left: 0;
  }
  .div_item_flex3_1_1 {
    width: 100%;
  }
  .div_item_flex3_1_2 {
    width: 100%;
    margin-left: 0;
    margin-top: 20px;
    height: auto;
  }
  .div-graph {
    width: 100%;
  }
  .div-space {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .div-dataset1 {
    width: 100%;
    padding: 10px;
    margin-right: 0;
  }
  .div-dataset2 {
    width: 100%;
    padding: 10px;
    margin-left: 0;
    margin-top: 20px;
  }
}
</style>